module.exports = __webpack_public_path__ + "static/media/hero-media4.f2a17d86.jpg";